import { Box, Checkbox } from '@mui/material';
import React, { useEffect } from 'react';
import { TagResponse } from 'src/features/alarm-rules/types';
import { SEPARATOR } from '../../config';
import {
  StyledAssetNameLabel,
  StyledGatewayNameLabel,
  gatewayNameBox,
  assetNameLabelBox,
  StyledDisplayName,
  modalContentSide,
  StyledModalContentSide,
  StyledModalContentRow,
} from './style';
import { useResponsive } from 'src/hooks/useResponsive';

type ModalContentRowProps = {
  values: any;
  tag: TagResponse;
  disabled?: boolean;
  siteName: string;
  siteId: string;
  setValue: (name: string, value: string) => void;
  isParticularChart?: boolean;
};

export const ModalContentRow = React.memo(
  ({
    tag,
    siteName,
    values,
    disabled = false,
    setValue,
    siteId,
    isParticularChart,
  }: ModalContentRowProps) => {
    const key = `row${SEPARATOR}${siteId}${SEPARATOR}${siteName}${SEPARATOR}${
      tag.rawInputName
    }${SEPARATOR}${tag.rawUnit}${SEPARATOR}${tag.gatewayId}${SEPARATOR}${
      tag.id
    }${SEPARATOR}${tag.displayName?.replace(/\./g, '(dot)')}${SEPARATOR}${tag.dataType}`;
    useEffect(() => {
      if (isParticularChart) return;
      setValue(key, 'false');
    }, [isParticularChart, setValue, siteId, tag, key]);

    const isMobile = useResponsive('down', 'sm');
    return siteId && tag.gatewayId && tag.id && tag.displayName && !tag.hidden && siteName ? (
      <StyledModalContentRow
        sx={{ cursor: disabled ? 'default' : 'none' }}
        onClick={(e: any) => {
          e.stopPropagation();
          if (disabled) return;
          setValue(key, (!(values[key] === 'true')).toString());
        }}
      >
        <Box sx={{ ...modalContentSide, opacity: disabled ? '0.5' : '1' }}>
          <Checkbox
            disabled={disabled}
            name={key}
            inputProps={{
              // @ts-ignore
              'data-sm': 'tag-checkbox',
            }}
            checked={values[key] === 'true'}
            onChange={(event) => {
              setValue(key, event.target.checked.toString());
            }}
          />

          <StyledDisplayName data-sm={tag?.displayName} isMobile={isMobile}>
            {tag?.displayName}
          </StyledDisplayName>
        </Box>
        <StyledModalContentSide isMobile={isMobile}>
          {tag?.gatewayName ? (
            <Box sx={gatewayNameBox}>
              <StyledGatewayNameLabel variant="caption">{tag.gatewayName}</StyledGatewayNameLabel>
            </Box>
          ) : null}
          {tag?.connectedAsset ? (
            <Box sx={assetNameLabelBox}>
              <StyledAssetNameLabel variant="caption">{tag.connectedAsset}</StyledAssetNameLabel>
            </Box>
          ) : null}
        </StyledModalContentSide>
      </StyledModalContentRow>
    ) : null;
  }
);
